import { assert } from '../../lib/assert-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageSystems } from './voyageSystems-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let useSystemTime = 2
  d.useSystemTimer += ds
  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    if (voyageSystems.testNoPower(obj)) {
      return
    }

    let possibleReports: string[] = []

    let status = voyageGameStatus.get()

    let report = ''
    if (status.hasBoarders.isActive) {
      possibleReports.push(...['Boarders!', 'Aliens!', 'Intruders detected!'])
    }
    if (status.hasFire.isActive) {
      possibleReports.push(...['FIRE!', 'Fire on deck', 'Smoke detected'])
    }

    if (status.hasBreach.isActive) {
      possibleReports.push(
        ...[
          'Hull breach!',
          'We are losing oxygen',
          'Hull damage detected',
          'Hull integrity compromised',
        ],
      )
    }

    if (status.oxygen < 25) {
      possibleReports.push('Oxygen level is critical')
    } else if (status.oxygen < 50) {
      possibleReports.push('Oxygen level is low')
    }

    if (status.power < 25) {
      possibleReports.push('Power level is critical')
    } else if (status.power < 50) {
      possibleReports.push('Power level is low')
    }

    if (possibleReports.length === 0) {
      possibleReports.push(
        ...[
          'All is well',
          'Nothing to report',
          'Internal sensors are clear',
          '',
        ],
      )
    } else {
      voyageSounds.playCompWarning1()
    }

    report = rando.sample(possibleReports)

    voyageCrew.say(obj, report)
  }
}
